// 🔔 Shared lock-on / alert sound pack — chime 🎵 · POGZILLA roar 🐲 · arcade coin 🕹️
let ctx = null;

export const playLockSound = () => {
  try {
    if (localStorage.getItem("airpog_voice_callouts") === "0") return;
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    ctx.resume?.();
    const kind = localStorage.getItem("airpog_lock_sound") || "chime";
    const t = ctx.currentTime;
    if (kind === "coin") {
      [[987.77, 0, 0.09], [1318.5, 0.09, 0.3]].forEach(([f, dt, dur]) => {
        const o = ctx.createOscillator(); const g = ctx.createGain();
        o.type = "square"; o.frequency.value = f;
        g.gain.setValueAtTime(0.0001, t + dt);
        g.gain.exponentialRampToValueAtTime(0.12, t + dt + 0.015);
        g.gain.exponentialRampToValueAtTime(0.0001, t + dt + dur);
        o.connect(g).connect(ctx.destination); o.start(t + dt); o.stop(t + dt + dur + 0.05);
      });
    } else if (kind === "roar") {
      [0, 7].forEach((det) => {
        const o = ctx.createOscillator(); const g = ctx.createGain();
        o.type = "sawtooth"; o.detune.value = det;
        o.frequency.setValueAtTime(200, t);
        o.frequency.exponentialRampToValueAtTime(48, t + 0.65);
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(0.2, t + 0.06);
        g.gain.exponentialRampToValueAtTime(0.0001, t + 0.7);
        o.connect(g).connect(ctx.destination); o.start(t); o.stop(t + 0.75);
      });
    } else {
      [523.25, 659.25, 783.99].forEach((f, i) => {
        const o = ctx.createOscillator(); const g = ctx.createGain();
        o.type = "sine"; o.frequency.value = f;
        const t0 = t + i * 0.09;
        g.gain.setValueAtTime(0.0001, t0);
        g.gain.exponentialRampToValueAtTime(0.16, t0 + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.32);
        o.connect(g).connect(ctx.destination); o.start(t0); o.stop(t0 + 0.36);
      });
    }
  } catch (e) { /* ignore */ }
};
